var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label-annotated"},[_c('span',{staticClass:"label-annotated-body"},[_vm._t("default")],2),(_vm.facet)?_c('span',{staticClass:"label-annotated-facet"},[_vm._v(_vm._s(_vm.facet))]):_vm._e(),(_vm.note)?_c('span',{staticClass:"label-annotated-note"},[_vm._v(_vm._s(_vm.note))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }